import { render } from "./multi-tab.vue?vue&type=template&id=a16211bc&scoped=true&ts=true"
import script from "./multi-tab.vue?vue&type=script&lang=ts"
export * from "./multi-tab.vue?vue&type=script&lang=ts"

import "./multi-tab.vue?vue&type=style&index=0&id=a16211bc&lang=less&scoped=true"

import exportComponent from "/root/workspace/LiYuLoginSaaS_ql2g/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a16211bc"]])

export default __exports__